import { render, staticRenderFns } from "./PlatformAccountCenter.vue?vue&type=template&id=07a81a08&scoped=true"
import script from "./PlatformAccountCenter.vue?vue&type=script&lang=js"
export * from "./PlatformAccountCenter.vue?vue&type=script&lang=js"
import style0 from "./PlatformAccountCenter.vue?vue&type=style&index=0&id=07a81a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a81a08",
  null
  
)

export default component.exports